import { render, staticRenderFns } from "./MedicalForm.vue?vue&type=template&id=5da2d920&%3Aid=formId&"
import script from "./MedicalForm.vue?vue&type=script&lang=js&"
export * from "./MedicalForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports